<template>
  <div>
    <speedHeader></speedHeader>
    <div class="list-body detect_body">
      <div class="list-body-container">
        <div>
          <div>
            <div class="detect-title">{{$t('cos.upload_domain_config')}}</div>
            <div>
              <qc-radio-group class="radio-container" v-model="uploadHostType">
                <qc-radio class="radio-container-item" :value="1" :title="$t('cos.default_domain')">{{$t('cos.default_domain')}}</qc-radio>
                <qc-radio class="radio-container-item" :value="2" :title="$t('cos.global_acceleration_domain')">{{$t('cos.global_acceleration_domain')}}
                  <label class="radio-container-item-subtitle">{{$t('cos.need_enable_global_acceleration')}}</label>
                </qc-radio>
                <qc-radio class="radio-container-item" :value="3" :title="$t('cos.custom_domain')">{{$t('cos.custom_domain')}}
                  <qc-input class="radio-container-item-input" :placeholder="$t('cos.enter_custom_domain')" style="margin-left: 10px;"
                            v-model="uploadHost"></qc-input>
                </qc-radio>
              </qc-radio-group>
            </div>
          </div>
          <div>
            <div class="detect-title">{{$t('cos.download_domain_config')}}</div>
            <div>
              <qc-radio-group class="radio-container" v-model="downloadHostType">
                <qc-radio class="radio-container-item" :value="1" :title="$t('cos.default_domain')">{{$t('cos.default_domain')}}</qc-radio>
                <qc-radio class="radio-container-item" :value="2" :title="$t('cos.global_acceleration_domain')">{{$t('cos.global_acceleration_domain')}}
                  <label class="radio-container-item-subtitle">{{$t('cos.need_enable_global_acceleration')}}</label>
                </qc-radio>
                <qc-radio class="radio-container-item" :value="3" :title="$t('cos.custom_domain')">{{$t('cos.custom_domain')}}
                  <qc-input class="radio-container-item-input" :placeholder="$t('cos.enter_custom_domain')" style="margin-left: 10px;"
                            v-model="downloadHost"></qc-input>
                </qc-radio>
              </qc-radio-group>
            </div>
          </div>
        </div>
        <div class="container-item-subtitle">{{$t('cos.speed_test_tip')}}</div>
        <qc-button class="container-button" type="default" title="默认按钮" @click="upload()">{{$t('cos.start_speed_test')}}</qc-button>
        <div class='speed_result_body'>
          <div v-if='uploadDetectState !== 0'>
            <div class='speed_result_title'>{{ uploadTitle }}</div>
            <div class='speed_result_progress' v-if='uploadDetectState !== 3'>
              <qc-progress class='speed_result_pregress_pre' :progress='uploadSpeedPro'></qc-progress>
            </div>
            <div class='speed_result_speed'>
              <div v-if='uploadDetectState === 2'>{{ uploadSpeedMax }}</div>
              <div v-if='uploadDetectState === 2'>{{ uploadSpeedAvg }}</div>
              <div v-if='uploadDetectState === 2'>{{ uploadSpeedMin }}</div>
              <div v-if='uploadDetectState === 1'>{{ uploadSpeed }}</div>
            </div>
          </div>
          <div v-if='downloadDetectState !== 0'>
            <div class='speed_result_title'>{{ downloadTitle }}</div>
            <div class='speed_result_progress' v-if='downloadDetectState !== 3'>
              <qc-progress class='speed_result_pregress_pre' :progress='downloadSpeedPro'></qc-progress>
            </div>
            <div class='speed_result_speed'>
              <div v-if='downloadDetectState === 2'>{{ downloadSpeedMax }}</div>
              <div v-if='downloadDetectState === 2'>{{ downloadSpeedAvg }}</div>
              <div v-if='downloadDetectState === 2'>{{ downloadSpeedMin }}</div>
              <div v-if='downloadDetectState === 1'>{{ downloadSpeed }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import speedHeader from '@/components/speed/header';
import * as utils from 'tools/utils';
import COS from 'cos-js-sdk-v5';

let uploadCos = null;

export default {
  components: {
    speedHeader,
  },
  data() {
    return {
      uploadTaskId: undefined,
      fileSize: 50 * 1024 * 1024,
      detectUrl: '',
      downloadHostType: 1,
      downloadHost: '',
      uploadHostType: 1,
      uploadHost: '',
      detectInfo: undefined,
      uploadDetectState: 0, // 0: 未检测, 1: 检测中, 2: 检测完成, 3: 检测失败
      downloadDetectState: 0, // 0: 未检测, 1: 检测中, 2: 检测完成, 3: 检测失败
      uploadSpeedMax: 0,
      uploadSpeedAvg: 0,
      uploadSpeedMin: 0,
      uploadSpeedPro: 0,
      uploadTitle: '',
      uploadSpeed: '',

      downloadSpeedMax: 0,
      downloadSpeedAvg: 0,
      downloadSpeedMin: 0,
      downloadSpeedPro: 0,
      downloadTitle: '',
      downloadSpeed: '',
    };
  },
  mounted() {
    try {
      if (window.location.search.length === 0) {
        this.$tip({
          message: this.$t('cos.please_enter_speed_test_parameters'),
          type: 'error',
        });
        return;
      }
      const detectInfo = utils.queryStringParse(window.location.search.substr(1));
      this.detectInfo = JSON.parse(utils.decodeBase64(detectInfo.detect_code));
      console.log(this.detectInfo);
    } catch (e) {
      this.$tip({
        message: this.$t('cos.speed_test_parameter_exception'),
        type: 'error',
      });
    }
  },
  watch: {},
  beforeDestroy() {
    if (this.uploadTaskId) {
      uploadCos.cancelTask(this.uploadTaskId);
    }
    this.delete();
  },
  methods: {
    resetUIData() {
      this.uploadDetectState = 0;
      this.downloadDetectState = 0;
      this.uploadSpeedMax = 0;
      this.uploadSpeedAvg = 0;
      this.uploadSpeedMin = 0;
      this.uploadSpeedPro = 0;
      this.uploadTitle = '';
      this.uploadSpeed = '';
      this.downloadSpeedMax = 0;
      this.downloadSpeedAvg = 0;
      this.downloadSpeedMin = 0;
      this.downloadSpeedPro = 0;
      this.downloadTitle = '';
      this.downloadSpeed = '';
    },
    upload() {
      if (!this.detectInfo || !this.detectInfo.sid || !this.detectInfo.skey || !this.detectInfo.token) {
        this.$tip({
          message: this.$t('cos.speed_test_parameter_exception'),
          type: 'error',
        });
        return;
      }
      if (this.uploadDetectState === 1 || this.downloadDetectState === 1) {
        this.$tip({
          message: this.$t('cos.speed_test_in_progress_please_wait'),
          type: 'error',
        });
        return;
      }
      const self = this;
      this.resetUIData();
      if (this.uploadHostType === 3 && this.uploadHost.length === 0) {
        this.$tip({
          message: this.$t('cos.please_enter_custom_upload_domain'),
          type: 'error',
        });
        return;
      }
      if (this.downloadHostType === 3 && this.downloadHost.length === 0) {
        this.$tip({
          message: this.$t('cos.please_enter_custom_download_domain'),
          type: 'error',
        });
        return;
      }
      this.uploadDetectState = 1;
      this.uploadTitle = this.$t('cos.upload_speed_test_in_progress_with_percent', { percent: '0%' });
      const beginTime = Date.now();
      let maxSpeed = 0;
      let minSpeed = 1000000;
      const cos = new COS({
        UseAccelerate: this.uploadHostType === 2,
        Domain: this.uploadHostType === 3 ? this.uploadHost : null, // 自定义域名
        SecretId: this.detectInfo.sid, // sts服务下发的临时 secretId
        SecretKey: this.detectInfo.skey, // sts服务下发的临时 secretKey
        SecurityToken: this.detectInfo.token, // sts服务下发的临时 SessionToken
      });
      uploadCos = cos;
      cos.uploadFile({
        Bucket: this.detectInfo.bucket,
        Region: this.detectInfo.region,
        Key: this.detectInfo.path,
        Body: this.getTempFile(this.fileSize), // 上传文件对象
        SliceSize: 1024 * 1024 * 1,
        onTaskReady(taskId) {
          self.uploadTaskId = taskId;
        },
        onProgress(progressData) {
          console.log(`${self.$t('cos.upload_completed')}: ${JSON.stringify(progressData)}`);
          if (progressData.speed > maxSpeed) {
            maxSpeed = progressData.speed;
          }
          if (progressData.speed < minSpeed && progressData.speed > 0) {
            minSpeed = progressData.speed;
          }
          self.uploadTitle = self.$t('cos.upload_speed_test_in_progress');
          self.uploadSpeed = `${utils.getSizeStr(progressData.speed)}/S`;
          self.uploadSpeedPro = progressData.percent;
        },
      }, (err, data) => {
        self.uploadTaskId = undefined;
        console.log(`${this.$t('cos.upload_completed')}: ${JSON.stringify(err || data)}`);
        const endTime = Date.now();
        if (err) {
          if (err.code === 'InvalidAccessKeyId') {
            self.uploadTitle = this.$t('cos.upload_speed_test_failed_link_expired_please_re_acquire');
          } else {
            self.uploadTitle = `${this.$t('cos.upload_speed_test_failed')}: ${err.message}`;
          }
          self.uploadDetectState = 3;
        } else {
          self.uploadDetectState = 2;
          self.uploadTitle = self.$t('cos.upload_speed_test_completed');
          self.uploadSpeedMin = `${self.$t('cos.slowest')}: ${utils.getSizeStr(minSpeed)}/S`;
          self.uploadSpeedMax = `${self.$t('cos.fastest')}: ${utils.getSizeStr(maxSpeed)}/S`;
          self.uploadSpeedAvg = `${self.$t('cos.average')}: ${utils.getSizeStr(self.fileSize / ((endTime - beginTime) / 1000))}/S`;
          self.download();
        }
      });
    },
    download() {
      this.downloadDetectState = 1;
      const beginTime = Date.now();
      let maxSpeed = 0;
      let minSpeed = 1000000;
      const self = this;
      const cos = new COS({
        UseAccelerate: this.downloadHostType === 2,
        Domain: this.downloadHostType === 3 ? this.downloadHost : null, // 自定义域名
        SecretId: this.detectInfo.sid, // sts服务下发的临时 secretId
        SecretKey: this.detectInfo.skey, // sts服务下发的临时 secretKey
        SecurityToken: this.detectInfo.token, // sts服务下发的临时 SessionToken
      });
      cos.getObject({
        Bucket: self.detectInfo.bucket,
        Region: self.detectInfo.region,
        Key: self.detectInfo.path,
        onProgress(progressData) {
          console.log(`${self.$t('cos.download_completed')}: ${JSON.stringify(progressData)}`);
          if (progressData.speed > maxSpeed) {
            maxSpeed = progressData.speed;
          }
          if (progressData.speed < minSpeed) {
            minSpeed = progressData.speed;
          }
          self.downloadTitle = self.$t('cos.download_speed_test_in_progress');
          self.downloadSpeed = `${utils.getSizeStr(progressData.speed)}/S`;
          self.downloadSpeedPro = progressData.percent;
        },
      }, (err, data) => {
        console.log(`${this.$t('cos.download_completed')}: ${JSON.stringify(err || data)}`);
        self.delete();
        const endTime = Date.now();
        if (err) {
          self.downloadDetectState = 3;
          self.downloadTitle = `${this.$t('cos.download_speed_test_failed')}: ${err.message}`;
        } else {
          self.downloadDetectState = 2;
          self.downloadTitle = self.$t('cos.download_speed_test_completed');
          self.downloadSpeedMin = `${self.$t('cos.slowest')}: ${utils.getSizeStr(minSpeed)}/S`;
          self.downloadSpeedMax = `${self.$t('cos.fastest')}: ${utils.getSizeStr(maxSpeed)}/S`;
          self.downloadSpeedAvg = `${self.$t('cos.average')}: ${utils.getSizeStr(self.fileSize / ((endTime - beginTime) / 1000))}/S`;
        }
      });
    },
    delete() {
      const cos = new COS({
        SecretId: this.detectInfo.sid, // sts服务下发的临时 secretId
        SecretKey: this.detectInfo.skey, // sts服务下发的临时 secretKey
        SecurityToken: this.detectInfo.token, // sts服务下发的临时 SessionToken
      });
      cos.deleteObject({
        Bucket: this.detectInfo.bucket,
        Region: this.detectInfo.region,
        Key: this.detectInfo.path,
      });
    },
    getTempFile(size) {
      const buffer = new ArrayBuffer(size);
      return buffer;
    },
  },
};
</script>

<style lang="scss" scoped>
$xs: 360px;
$sm: 600px;
.list-body-container {
  background: #fff;
  padding: 10px 20px 30px 20px;
}

.detect-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-top: 10px;
  padding: 10px 0 10px 0;
}

.detect-url-input {
  max-width: 500px;
  height: 100px;
}

.radio-container-item {
  font-size: 13px;
  align-content: center;
  height: 36px;
  max-width: 500px;
  width: 100%;
  display: flex;
  align-items: center;
}

.radio-container {
  display: flex;
  flex-direction: column;
}

.radio-container-item-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #666;
}

.radio-container-item-input {
  margin: 0 auto;
  flex: 1;
}

.container-item-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #666;
  margin-top: 10px;
}

.container-result {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-top: 10px;
}

.container-button {
  font-size: 14px;
  margin-top: 10px;
  max-width: 500px;
  height: 40px;
  width: 100%;
}

.speed_result_speed {
  font-size: 14px;
  color: #0182ff;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.speed_result_title {
  font-size: 15px;
  margin-top: 16px;
}

.speed_result_body {
  max-width: 500px;
  width: 100%;
}

.speed_result_progress {
  font-size: 14px;
  width: 100%;
  height: 36px;
  display: flex;
  flexdirection: row;
  align-items: center;
}

.speed_result_pregress_title {
}

.speed_result_pregress_pre {
  margin-top: 24px;
  height: 6px;
  width: 100%;
  flex: 1;
}

.detect_body {
  overflow: auto;
  height: calc(100vh - 60px);
}
</style>
